import "./CardHeader.css";
import logo from "../../../../assets/icons/gspen-logo.png";
import BackButton from "../Buttons/BackButton/BackButton";

function CardHeader(props: { button?: null | (() => void); title: string }) {
  const backButton = props.button ? (
    <BackButton title="უკან" onClick={props.button} />
  ) : null;
  return (
    <div className={`card-header df fdr aic ${backButton ? "jcsb" : "jcc"}`}>
      {backButton}
      {/* <h2
        className="gnspen-logo"
        style={{ width: "var(--card-header-element)" }}
      >
        <b>{props.title}</b>
      </h2> */}
      <img
        src={logo}
        alt="logo"
        style={{
          width: "auto",
          height: "40px",
          marginBottom: "5px",
          padding: 0,
        }}
      />
    </div>
  );
}

export default CardHeader;
